import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Drawer as DrawerComponent,
  Hidden,
  List,
  ListItem,
  ListItemText,
  SvgIcon,
  IconButton,
  Divider,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import settings from './settings';
import { useDispatch, useSelector } from 'react-redux';
import { getIsShrinkSidebar } from '../stores/sidebar/getters';
import { toggleSidebar } from '../stores/sidebar/actions';
import CreateButton from './CreateAlgo/CreateButton';
import SupportButton from './SupportButton';
import { useLocation } from 'react-router-dom/';
import BookOutlinedIcon from '@material-ui/icons/BookOutlined';
import FeedbackIcon from '@material-ui/icons/Feedback';
import { getBotNotificationsData } from '../stores/bot-notifications/getters';
import TooltipEnclosureMiddle from './TooltipEnclosureMiddle';
import { isMobile } from '../helpers/mobile-detect';
import AnnouncementUnreadCount from '../partials/NotificationAlerts/AnnouncementUnreadCount';
import NotificationsActiveOutlinedIcon from '@material-ui/icons/NotificationsActiveOutlined';
import AnnouncementOutlinedIcon from '@material-ui/icons/AnnouncementOutlined';

const { drawerWidth } = settings;

const useStyles = makeStyles((theme) => ({
  drawer: {
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerShrink: {
    [theme.breakpoints.up('md')]: {
      width: 80,
      flexShrink: 0,
    },
  },
  list: {
    paddingTop: 7,
  },
  listShrink: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    paddingBottom: theme.spacing(6),
    '& > div': {
      minHeight: '51px',
    },
  },
  listItem: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    minHeight: 55,

    '&.shrinkSidebar': {
      '&  a': {
        [theme.breakpoints.up('md')]: {
          paddingLeft: 28,
          paddingRight: 28,
        },
      },
    },

    '&  a': {
      paddingLeft: 16,
      paddingRight: 0,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      minHeight: 55,
      textDecoration: 'none',
      color: 'inherit',
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      position: 'relative',
    },
    '& .drawerIcon': {
      fill: 'var(--color-fontColors-dark)',
      color: 'var(--color-fontColors-dark)',
    },

    '&.isActive': {
      '& .MuiListItemText-root > span': {
        color: 'var(--color-colorPrimary-main)',
      },

      '& .drawerIcon': {
        fill: 'var(--color-colorPrimary-main)',
        color: 'var(--color-colorPrimary-main)',
      },
    },
  },
  listItemCreateButton: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 12,
    paddingBottom: 0,
    minHeight: 55,
    justifyContent: 'center',
    flexWrap: 'wrap',

    '& .create-button': {
      width: '100%',
      maxWidth: 178,
    },

    '& .MuiDivider-root': {
      width: 'calc(100% - 32px)',
      marginTop: 16,
      marginBottom: 10,
    },

    '&.shrinkSidebar': {
      '& .create-button': {
        [theme.breakpoints.up('md')]: {
          minWidth: 'initial',
          maxWidth: 50,
        },
      },

      '& .create-button__text': {
        [theme.breakpoints.up('md')]: {
          display: 'none',
        },
      },

      '& span': {
        '&:first-child': {
          [theme.breakpoints.up('md')]: {
            margin: '0',
          },
        },
      },
    },

    // 'hr' {
    //   widt
    // }
  },
  listItemDocumentation: {
    paddingLeft: 0,
    paddingRight: 0,
    justifyContent: 'center',

    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  listItemText: {
    '& > span': {
      fontWeight: 500,
      fontSize: '1rem',
      marginLeft: 7,
      letterSpacing: 0,
      color: 'var(--color-fontColors-dark)',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  drawerDesktop: {
    width: drawerWidth,
    zIndex: 500,
  },
  DrawerFooter: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    marginBottom: 20,

    [theme.breakpoints.up('md')]: {},
  },
  shrinkArrow: {
    justifyContent: 'flex-end',
    display: 'flex',
    '& .arrow': {
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
      marginRight: theme.spacing(3),
      transform: 'rotate(90deg)',
      // transform: 'rotate(270deg)',
    },
  },
  shrinkArrowShrink: {
    justifyContent: 'center',
    display: 'flex',
    '& .arrow': {
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
      transform: 'rotate(270deg)',
    },
  },
  drawerDesktopShrink: {
    width: 'initial',
    zIndex: 500,
    '& .MuiListItem-root': {
      minHeight: '51px',
    },
    '& .MuiListItemText-root': {
      display: 'none',
    },
  },
  NotificationsAlertIcon: {
    position: 'absolute',
    fontSize: '1.3rem',
    color: 'var(--color-colorsForValuesRed)',
    top: 2,
    left: 39,
    '&.shrinkSidebar': {
      [theme.breakpoints.up('md')]: {
        top: 2,
        left: 49,
      },
    },
  },
  AnnouncementCount: {
    position: 'absolute',
    top: 17,
    right: 8,
    '&.shrinkSidebar': {
      [theme.breakpoints.up('md')]: {
        top: 3,
        left: 39,
        right: 'initial',
      },
    },
  },
  TooltipHolder: {
    '&.shrinkSidebar': {
      [theme.breakpoints.up('md')]: {
        alignItems: 'center',
        display: 'flex',
        width: '100%',
        height: 'inherit',
        justifyContent: 'center',
      },
    },
  },
}));

function useIsTelegramConfigured() {
  const isEnabled = useSelector((state) => {
    const { enabled = false } = getBotNotificationsData(state);

    return enabled;
  });

  const mediumsList = useSelector((state) => {
    const { mediums = [] } = getBotNotificationsData(state);

    return mediums;
  });

  if (!isEnabled) {
    return false;
  }

  const telegram = mediumsList.find((medium) => medium?.name === 'telegram');

  if (!telegram) {
    return false;
  }

  const isConfigured = telegram?.isConfigured ? true : false;

  if (!isConfigured) {
    return false;
  }

  return true;
}

function NoticationsIcon({ id = '' }) {
  const classes = useStyles();
  const isTelegramConfigured = useIsTelegramConfigured();
  const isNotifications = id === 'notifications';
  const shrinkSidebar = useSelector(getIsShrinkSidebar);

  if (!isNotifications) {
    return <></>;
  }

  if (isTelegramConfigured) {
    return <></>;
  }

  return (
    <FeedbackIcon
      className={`${classes.NotificationsAlertIcon}  ${
        shrinkSidebar ? 'shrinkSidebar' : ''
      } NotificationsAlertIcon`}
    />
  );
}

function AnnouncementCount({ id = '' }) {
  const classes = useStyles();
  const isAnnouncements = id === 'announcements';
  const shrinkSidebar = useSelector(getIsShrinkSidebar);

  if (!isAnnouncements) {
    return <></>;
  }

  return (
    <AnnouncementUnreadCount
      className={`${classes.AnnouncementCount}  ${
        shrinkSidebar ? 'shrinkSidebar' : ''
      } AnnouncementCount`}
    />
  );
}

function TooltipHolder({ title, children }) {
  const classes = useStyles();
  const shrinkSidebar = useSelector(getIsShrinkSidebar);

  if (isMobile) {
    return <>{children}</>;
  }

  if (!shrinkSidebar) {
    return <>{children}</>;
  }

  return (
    <TooltipEnclosureMiddle
      title={title}
      className={`${classes.TooltipHolder} ${
        shrinkSidebar ? 'shrinkSidebar' : ''
      }`}
    >
      {children}
    </TooltipEnclosureMiddle>
  );
}

function DrawerMenuItem({ onClick, route }) {
  const classes = useStyles();
  const shrinkSidebar = useSelector(getIsShrinkSidebar);
  const location = useLocation();
  const isActive =
    location?.pathname &&
    route?.path &&
    location?.pathname.startsWith(route?.path)
      ? true
      : false;

  return (
    <ListItem
      button
      className={`${classes.listItem} ${isActive ? 'isActive' : ''} ${
        shrinkSidebar ? 'shrinkSidebar' : ''
      }`}
    >
      <TooltipHolder title={route.name}>
        <NavLink to={route.path} activeClassName="active" onClick={onClick}>
          <NoticationsIcon id={route?.id || ''} />
          <AnnouncementCount id={route?.id || ''} />
          {route.icon ? (
            <SvgIcon component={route.icon} className="drawerIcon" />
          ) : null}
          <ListItemText primary={route.name} className={classes.listItemText} />
        </NavLink>
      </TooltipHolder>
    </ListItem>
  );
}

function DrawerMenuItemExternal({ route }) {
  const classes = useStyles();
  const shrinkSidebar = useSelector(getIsShrinkSidebar);

  return (
    <ListItem
      button
      className={`${classes.listItem} ${shrinkSidebar ? 'shrinkSidebar' : ''}`}
    >
      <TooltipHolder title={route.name}>
        <a href={route.path} target="_blank" rel="noopener noreferrer">
          {route.icon ? (
            <SvgIcon component={route.icon} className="drawerIcon" />
          ) : null}
          <ListItemText primary={route.name} className={classes.listItemText} />
        </a>
      </TooltipHolder>
    </ListItem>
  );
}

const DrawerMenu = ({ routes, onItemClick }) => {
  const classes = useStyles();
  const shrinkSidebar = useSelector(getIsShrinkSidebar);

  return (
    <div>
      <div className={classes.toolbar} />
      <List className={classes.list}>
        <ListItem
          className={`${classes.listItemCreateButton} ${
            shrinkSidebar ? 'shrinkSidebar' : ''
          }`}
        >
          <CreateButton isDrawer />
          <Divider />
        </ListItem>
        {routes
          .filter((route) => !route.excludeFromSidebar)
          .map((route) => (
            <DrawerMenuItem
              button
              key={route.id}
              route={route}
              onClick={onItemClick}
            />
          ))}
      </List>
    </div>
  );
};

DrawerMenu.defaultProps = {
  onItemClick: () => {},
};

DrawerMenu.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
  onItemClick: PropTypes.func,
};

function DrawerFooter({ children, className }) {
  const classes = useStyles();
  const shrinkSidebar = useSelector(getIsShrinkSidebar);

  return (
    <div
      className={`DrawerFooter ${classes.DrawerFooter} ${
        shrinkSidebar ? 'shrinkSidebar' : ''
      } ${className}`}
    >
      {children}
    </div>
  );
}

function FooterContent() {
  const classes = useStyles();
  const shrinkSidebar = useSelector(getIsShrinkSidebar);

  return (
    <>
      <DrawerMenuItem
        button
        route={{
          path: '/announcements',
          id: 'announcements',
          name: 'Announcements',
          icon: AnnouncementOutlinedIcon,
        }}
      />
      <DrawerMenuItem
        button
        route={{
          path: '/alerts',
          id: 'alerts',
          name: 'Alerts',
          icon: NotificationsActiveOutlinedIcon,
        }}
      />
      <DrawerMenuItemExternal
        route={{
          path: 'https://quantiply.tech/documentation',
          name: 'Docs',
          icon: BookOutlinedIcon,
        }}
      />
      <ListItem
        className={`${classes.listItemDocumentation} ${
          shrinkSidebar ? 'shrinkSidebar' : ''
        }`}
      >
        <SupportButton drawer />
      </ListItem>
    </>
  );
}

const Drawer = ({ handleDrawerToggle, mobileOpen, routes }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const theme = useTheme();
  const shrinkSidebar = useSelector(getIsShrinkSidebar);

  const toggleShrinkSidebar = () => {
    dispatch(toggleSidebar());
  };

  return (
    <nav
      className={shrinkSidebar ? classes.drawerShrink : classes.drawer}
      id="drawer-main"
    >
      <Hidden mdUp implementation="css">
        <DrawerComponent
          variant="temporary"
          anchor={theme.direction === 'rtl' ? 'right' : 'left'}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <DrawerMenu routes={routes} onItemClick={handleDrawerToggle} />

          <DrawerFooter>
            <FooterContent />
          </DrawerFooter>
        </DrawerComponent>
      </Hidden>
      <Hidden smDown implementation="css">
        <DrawerComponent
          classes={{
            paper: shrinkSidebar
              ? classes.drawerDesktopShrink
              : classes.drawerDesktop,
          }}
          variant="permanent"
          open
          PaperProps={{ elevation: 3 }}
        >
          <DrawerMenu routes={routes} />
          <DrawerFooter>
            <FooterContent />
            <div
              className={
                shrinkSidebar ? classes.shrinkArrowShrink : classes.shrinkArrow
              }
            >
              <IconButton onClick={toggleShrinkSidebar} className="arrow">
                <ExpandMoreIcon />
              </IconButton>
            </div>
          </DrawerFooter>
        </DrawerComponent>
      </Hidden>
    </nav>
  );
};

Drawer.defaultProps = {
  routes: [{}],
};

Drawer.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
  mobileOpen: PropTypes.bool.isRequired,
};

export default Drawer;
